var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"centerRight2"}},[_c('div',{staticClass:"bg-color-black"},[_c('div',{staticClass:"d-flex pt-2 pl-2"},[_c('span',{staticClass:"text mx-2"},[_vm._v("空气质量5日预报")]),_c('dv-decoration-1',{staticClass:"dv-dec-1"})],1),_c('div',{staticClass:"d-flex ai-center"},[_c('AirQualityForecast')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }